// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dshop-render{margin:0 auto;width:12.8rem}.dshop-render dd,.dshop-render h1,.dshop-render h2,.dshop-render h3,.dshop-render h4,.dshop-render h5,.dshop-render h6,.dshop-render legend{margin:0}.dshop-render ul{margin:0;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
